<template>
    <app-dlg
            v-if="shownRelay"
            :show-dlg.sync="shownRelay"
            title="Select Columns"
            :default-padding="false"
    >

        <app-list
                v-model="$store.state.ref.dashboard.employeesSelectedColumns"
                :items="headers"
                :multiple="true"
                headline-key="text"
                item-key="value"
                sub-line-key="description"
                :show-check-boxes="true"
                :return-object="false"
                class="fill-height of-y"
                :height="400"
                @input="updateSelections"
        />

        <template v-slot:actions>
            <v-btn
                    @click="$store.state.ref.dashboard.employeesSelectedColumns = [...$store.state.defaultSelections.employeesSelectedColumns]; updateSelections()"
                    small
                    class="ml-2"
                    color="blue"
                    outlined
                    size="small"
            >
                Reset Selections
            </v-btn>
            <v-btn
                    @click="shownRelay = false"
                    small
                    class="ml-2"
                    color="secondary"
                    variant="contained"
                    size="small"
            >
                Done
            </v-btn>
        </template>
    </app-dlg>
</template>

<script>
import AppDlg from "@/components/Shared/AppDlg";
import AppList from "@/components/Shared/AppList/AppList";
import {mapActions} from "vuex";
export default {
    name: "AppEmployeeStatsSelectColumnsDlg",
    components: {AppList, AppDlg},
    props: {
        shown: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            headers: [
                {text: 'Name', value: 'employeeName', description: 'Employee name'},
                {text: 'Team', value: 'teamName', description: 'Team name'},
                {text: 'Active Time', value: 'activeTime', description: 'Total time active'},
                {text: 'Productive', value: 'ptt', description: 'Total time productive'},
                {text: 'Productive Normal', value: 'ptn', description: 'Time productive during working hours'},
                {text: 'Productive Overtime', value: 'pto', description: 'Time productive outside of working hours'},
                {text: 'Unproductive', value: 'utt', description: 'Total time unproductive'},
                {text: 'Unproductive Normal', value: 'utn', description: 'Time unproductive during working hours'},
                {text: 'Unproductive Overtime', value: 'uto', description: 'Time unproductive outside of working hours'},
                {text: 'Neutral', value: 'ntt', description: 'Total time neutral'},
                {text: 'Neutral Normal', value: 'ntn', description: 'Time neutral during working hours'},
                {text: 'Neutral Overtime', value: 'nto', description: 'Time neutral outside of working hours'},
                {text: 'Target', value: 'ttt', description: 'Total target duration'},
                {text: 'Idle', value: 'idleTime', description: 'Total idle duration'},
                {text: 'Productive Target %', value: 'productivityTarget', description: 'Total productivity vs total target'},
                {text: 'Productive Active %', value: 'productivityActive', description: 'Total productivity vs total active'},
                {text: 'Productive Normal Target %', value: 'productivityNormalTarget', description: 'Total productivity in working hours vs total target'},

            ],
        }
    },
    methods: {
        ...mapActions(['updateSelections'])
    },
    computed: {
        shownRelay: {
            get() {
                return this.shown
            },
            set(val) {
                this.$emit('update:shown', val)
            }
        }
    },
}
</script>

<style scoped>

</style>